import React from 'react';

interface CloseIconProps {
  color?: string;
}

export const CloseIcon = (props: CloseIconProps) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      xmlns="http://www.w3.org/2000/svg"
      fill={props.color ? props.color : '#ffffff'}
      role="img"
    >
      <path d="M20.956 3.985l-.942-.941L12 11.059 3.985 3.044l-.941.941L11.059 12l-8.015 8.015.941.941L12 12.941l8.014 8.015.942-.941L12.941 12z" />
    </svg>
  );
};
